import React, { useMemo, useState } from 'react';
import './GeneralSidebar.css';

type MainSectionId = 'home' | 'performance' | 'ad-tracking' | 'tools' | 'control';

type MainSection = {
  id: MainSectionId;
  label: string;
  icon: string; // Material Icons glyph name
  subitems: string[];
};

type GeneralSidebarProps = {
  isCollapsed: boolean;
  onToggleCollapsed: () => void;
};

export function GeneralSidebar({ isCollapsed, onToggleCollapsed }: GeneralSidebarProps) {
  const sections = useMemo<MainSection[]>(
    () => [
      {
        id: 'home',
        label: 'HOME',
        icon: 'home',
        subitems: ['Home', 'Dashboard', 'Statistics', 'Advertisers', 'Offers'],
      },
      {
        id: 'performance',
        label: 'PERFORMANCE',
        icon: 'rocket_launch',
        subitems: ['Performance', 'KPIs', 'Reports'],
      },
      {
        id: 'ad-tracking',
        label: 'AD TRACKING',
        icon: 'power_settings_new',
        subitems: ['Ad Tracking', 'Placements', 'Pixel helpers'],
      },
      {
        id: 'tools',
        label: 'TOOLS',
        icon: 'build',
        subitems: ['Tools', 'Integrations', 'Logs'],
      },
      {
        id: 'control',
        label: 'CONTROL',
        icon: 'widgets',
        subitems: ['Control', 'Rules', 'Automation'],
      },
    ],
    []
  );

  const [activeId, setActiveId] = useState<MainSectionId>('home');
  const activeSection = sections.find((s) => s.id === activeId) ?? sections[0];
  return (
    <aside
      className={`general-sidebar ${isCollapsed ? 'general-sidebar-collapsed' : 'general-sidebar-expanded'}`}
      aria-label="Sidebar de navegación"
    >
      <div className="general-sidebar-static">
        <button
          type="button"
          className="gs-hamburger"
          onClick={onToggleCollapsed}
          aria-label={isCollapsed ? 'Abrir sidebar' : 'Colapsar sidebar'}
        >
          <span className="material-icons gs-hamburger-icon" aria-hidden="true">
            menu
          </span>
        </button>

        {sections.map((section) => (
          <button
            key={section.id}
            type="button"
            className={`gs-nav-item ${activeId === section.id ? 'gs-nav-item-active' : ''}`}
            onClick={() => setActiveId(section.id)}
            aria-label={section.label}
          >
            <span className="material-icons gs-nav-icon" aria-hidden="true">
              {section.icon}
            </span>
            <span className="gs-nav-label">
              {section.label.charAt(0) + section.label.slice(1).toLowerCase()}
            </span>
          </button>
        ))}
      </div>

      {!isCollapsed && (
        <div className="general-sidebar-collapsible">
          <div className="gs-platform-header">
            <span className="gs-platform-name">Aftrad</span>
          </div>

          <div className="gs-collapsible-inner">
            <div className="gs-section-title">
              <span className="material-icons gs-section-title-icon" aria-hidden="true">
                {activeSection.icon}
              </span>
              <span>{activeSection.label}</span>
            </div>

            <div className="gs-subitems">
              {activeSection.subitems.map((item) => (
                <div key={item} className="gs-subitem">
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </aside>
  );
}

